import { createApi } from "@reduxjs/toolkit/query/react";

import { baseQueryWithReauth } from "../baseQueryWithReauth";

interface IValidateFastrPinRequest {
  pin: string;
}

export const fastrAppLinksApi = createApi({
  reducerPath: "fastrAppLinksApi",
  baseQuery: baseQueryWithReauth(`${process.env.REACT_APP_API_HOST}api/v1`),
  endpoints: (build) => ({
    // POST api/v1/fastrapplinks/validate-pin (documentmanager
    // FastrAppLinksController.ValidatePin) — returns whether the PIN matches
    // the practice's FASTR App Link PIN. The practice header is injected by
    // baseQueryWithReauth.
    validateFastrPin: build.mutation<boolean, IValidateFastrPinRequest>({
      query: ({ pin }) => ({
        url: "fastrapplinks/validate-pin",
        method: "POST",
        body: { pin },
      }),
    }),
  }),
});

export const { useValidateFastrPinMutation } = fastrAppLinksApi;
